import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ImportType } from 'src/app/enums/ImportType';
import { ContextService } from 'src/app/services';
import { BlobFiscalService, DataImportService, IDataImport, ISaveResult } from 'src/app/xena-api';

@Component({
    selector: 'app-import-saf-t',
    templateUrl: './import-saf-t.component.html',
    styleUrls: ['./import-saf-t.component.scss'],
    standalone: false
})
export class ImportSafTComponent {
  open: boolean = true;
  valid: boolean | null = null;
  form: UntypedFormGroup;
  currentStep: number = 1;
  importing: boolean;
  fileBuffer: ArrayBuffer | null = null;

  constructor(private fb: UntypedFormBuilder, private fileBlobService: BlobFiscalService,
    private dataImportService: DataImportService, protected context: ContextService) {
    this.form = this.fb.group({
      filePicker: this.fb.group({
        selectedFile: [null, Validators.required],
      }),
    });
  }

  get filePicker(): UntypedFormGroup {
    return <UntypedFormGroup>this.form.get('filePicker');
  }

  get file(): FormData {
    const dataFile = this.filePicker.get('selectedFile').value;
    const formdata = new FormData();
    formdata.append('file', dataFile);
    return formdata;
  }

  onFileSelected(arrayBuffer: ArrayBuffer): void {
    this.valid = null;
    this.fileBuffer = arrayBuffer;
    this.processFile();
  }

  processFile(): void {
    if (!this.fileBuffer) return;

    const uint8Array = new Uint8Array(this.fileBuffer);
    const textDecoder = new TextDecoder();
    const xmlString = textDecoder.decode(uint8Array);
    this.valid = this.checkForHeaderTag(xmlString)
  }

  checkForHeaderTag(content: string): boolean {
    const fullHeaderTag = new RegExp(/\<((?:[a-z0-9]+:)?header)\>[\s\S]*?\<\/\1\>/gi)

    const fullHeaderTags = content.match(fullHeaderTag) || [];
    return fullHeaderTags.length == 1;
  }

  //BUTTON CONTROLS
  cancel() {
    this.open = false;
    this.form.reset();
  }

  async import() {
    let dataImport: IDataImport = {
      importType: ImportType.SAFT,
      fiscalSetupId: this.context.fiscalId,
      description: $localize`:@@import_Saf-T_data_import_description:SAF-T import`
    };

    if (!this.hasFileData(this.file) || !this.valid) {
      return;
    }
    this.importing = true;
    const relationType = 'DataImport';
    dataImport = await this.dataImportService.save(dataImport).toPromise();

    if (!dataImport) {
      return;
    }
    let documentResponse: ISaveResult = null;
    await this.fileBlobService.postByType(relationType, dataImport.id, this.file)
      .toPromise().then(r => {
        if (r === null) {
          throw new Error($localize`:@@import_Saf-T_no_response_message:No response available`);
        }
        documentResponse = r;
        this.open = !documentResponse.success;
        this.importing = documentResponse.success;
      })
      .catch(ex => {
        this.importing = false;
        this.open = true;
        throw new Error(ex);
      });

    if (documentResponse.success) {
      await this.dataImportService.triggerImport(dataImport.id).toPromise();
    }
  }

  hasFileData(formData: FormData): boolean {
    let hasFile = false;

    formData.forEach((value, key) => {
      if (value instanceof File) {
        hasFile = true;
      }
    });

    return hasFile;
  }

}
